
define(
	'MHIOpenCloseBanner.Main'
,   [
		'MHIOpenCloseBanner.Main.View'
	]
,   function (MainView)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');	
			if (layout) {
				layout.addChildView('Message.Placeholder', function() { 
					return new MainView({ container: container });
				});
			}
		}
	};
});
